<template>
  <div>
    <q-dialog
      :visible.sync="dialogVisible"
      title="到货计划"
      :innerHeight="120"
      :innerScroll="false"
      width="400px"
      @cancel="updateVal"
      @confirm="confirm"
      @close="updateVal"
      :loading="loadingBth"
    >
      <!-- // 业务 -->
      <el-form :model="form" size="small" :inline="true" :rules="rules" ref="ruleForm" label-width="110px" v-loading="loading">
        <el-form-item label="计划到货时间" prop="deviceTime">
          <el-date-picker
            v-model="form.deviceTime"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="配货人员" prop="distributionPerson">
          <!-- <el-input v-model.trim="form.distributionPerson" :maxlength="64"/> -->
          <el-select 
            v-model="form.distributionPersonId"
            filterable=""
            placeholder="请选择"
            >
            <el-option
              v-for="item in userList"
              :key="item.userId"
              :label="`${item.userName}${item.workNo ? '-' + item.workNo : ''}`"
              :value="item.userId">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </q-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import axios from "@/utils/axiosInstance";
export default {
  model: {
    prop: 'visible',
    event: 'input'
  },
  props: {
    visible: Boolean,
    skuId: String|Number,
    skuCode: String|Number,
    spuId: String|Number
  },
  data() {
    return {
      dialogVisible: false,
      // 业务
      form: {
        deviceTime: '',
        distributionPersonId: ''
      },
      rules: {
        deviceTime: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        distributionPersonId: [
          { required: true, message: '不能为空', trigger: 'change' },
          // { min: 1, max: 64, message: '长度在 1 到 64 个字符', trigger: 'blur' }
        ]
      },
      loading: false,
      loadingBth: false,
      userList: []
    }
  },
  computed: {
    skuIds() {
      if(this.skuId instanceof Array) {
        return this.skuId
      }else{
        return [this.skuId]
      }
    },
    skuCodes() {
      if(this.skuCode instanceof Array) {
        return this.skuCode
      }else{
        return [this.skuCode]
      }
    },
  },
  mounted() {
    this.dialogVisible = this.visible;
    this.getUserList()
    // 业务
  },
  methods: {
    updateVal() {
      this.dialogVisible = false;
      setTimeout(_=>{
        this.$emit('input', false)
      },200)
    },
    confirm() {
      this.loadingBth = true
      this.$refs['ruleForm'].validate(valid => {
        if(!valid) return;
        let params = {
          data: []
        }
        this.skuIds.forEach((item, index) => {
          params.data.push({
            ...this.form,
            deviceTime: moment(this.form.deviceTime).format('YYYY-MM-DD'),
            spuId: this.spuId,
            skuId: item,
            skuCode: this.skuCodes[index],
            remarks: '',
            distributionPerson: this.form.distributionPersonId ? this.userList.find(v=>v.userId == this.form.distributionPersonId).userName : ""
          })
        });
        this.loading = true;
        this.$q.newProduct.submitArrivalPlan(params)
          .then(({success}) => {
            if (success) {
              this.$notify.success({
                title: '成功',
                message: '提交到货计划成功',
              });
              this.updateVal();
              this.skuIds.length === 1 && this.$emit('success', {
                skuCode: this.skuCodes[0],
                skuId: this.skuIds[0]
              });
              this.skuIds.length > 1 && this.$emit('batchSuccess');
            }
          })
          .finally(() => {
            this.loading = false;
            this.loadingBth = false;
          });
      })
    },
    getUserList() {
      let data = {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "getUserInfoByName",
      }
      axios.post(`/ec-pc-api/custom/reports/data/getUserInfoByName`, data).then((res) => {
        if (res.code == 200) {
          console.log(res.data);
          this.userList = res.data.list;
        }
      });
    },
    // 业务

  }
}
</script>

<style>

</style>